var showAxisLabels = false;
export var chartOptions = function chartOptions(theme) {
  return {
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    chart: {
      type: 'column',
      backgroundColor: theme.chartsBackgroundColor
    },
    legend: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    xAxis: {
      title: {
        enabled: false,
        text: 'Fondo'
      },
      labels: {
        enabled: false
      },
      categories: []
    },
    yAxis: {
      endOnTick: false,
      showLastLabel: false,
      showFirstLabel: false,
      title: {
        enabled: showAxisLabels,
        text: 'Rentabilidad'
      }
    },
    tooltip: {
      headerFormat: '',
      pointFormat: '{point.name}<br>{point.y:.2f}%'
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 1,
        zones: [{
          value: 0,
          borderColor: 'rgb(199, 0, 0)',
          color: 'rgba(199, 0, 0, 0.1)'
        }, {
          borderColor: 'rgb(41, 203, 130)',
          color: 'rgba(41, 203, 130, 0.1)'
        }]
      }
    },
    series: []
  };
};